import { useMemo } from "react";
import urlApi from "shared/actions/urlApi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { CustomDropdown } from "./styles";
import { CreateLinkTo } from "shared/constants/linkTo";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const CreatePresentationButton = () => {
    const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
    const dispatch = useDispatch();
    const history = useHistory();

    const { i18n, t } = useTranslation();

    useEffect(() => {
        urlApi()
            .getLendPresTagsTree(i18n.language)
            .then((tree: any[]) => {
                const options = tree?.[0]?.additionalTags || [];
                setProTypeOptions(options);
            })
            .catch(err => {
                console.error('Не удалось загрузить типы проектов', err);
            });
    }, []);

    const options = useMemo(() => {
        return proTypeOptions.map((tag: any) => {
            const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
            return {
                label: nameObj?.name || tag.title,
                value: tag.tagId,
            };
        });
    }, [i18n.language, proTypeOptions]);

    return (
            <ProjectEditPageGridInput isColumns>
                <CustomDropdown
                    lang={i18n.language}
                    value={navProTypeValue}
                    onChange={(option: any) => {
                        history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
                    }}
                    onMenuOpen={() => {
                        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }));
                        document.body.click();
                    }}
                    options={options}
                    placeholder={t("nav.create_button.create_presentation")}
                />
            </ProjectEditPageGridInput>
    )
}

export default CreatePresentationButton;import { useMemo } from "react";
import urlApi from "shared/actions/urlApi";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import { CustomDropdown } from "./styles";
import { CreateLinkTo } from "shared/constants/linkTo";
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";

const CreatePresentationButton = () => {
    const [proTypeOptions, setProTypeOptions] = useState<{ label: string; value: string }[]>([]);
    const [navProTypeValue, setNavProTypeValue] = useState<{ label: string; value: string } | null>(null);
    const dispatch = useDispatch();
    const history = useHistory();

    const { i18n, t } = useTranslation();

    useEffect(() => {
        urlApi()
            .getLendPresTagsTree(i18n.language)
            .then((tree: any[]) => {
                const options = tree?.[0]?.additionalTags || [];
                setProTypeOptions(options);
            })
            .catch(err => {
                console.error('Не удалось загрузить типы проектов', err);
            });
    }, []);

    const options = useMemo(() => {
        return proTypeOptions.map((tag: any) => {
            const nameObj = tag.name?.find((n: any) => n.lang.toLowerCase() === i18n.language);
            return {
                label: nameObj?.name || tag.title,
                value: tag.tagId,
            };
        });
    }, [i18n.language, proTypeOptions]);

    return (
            <ProjectEditPageGridInput isColumns>
                <CustomDropdown
                    lang={i18n.language}
                    value={navProTypeValue}
                    onChange={(option: any) => {
                        history.push(CreateLinkTo.projectCreate(), { selectedType: option.value });
                    }}
                    onMenuOpen={() => {
                        dispatch(NavbarSearchActions.setNavbarSearchToggle({ data: false }));
                        document.body.click();
                    }}
                    options={options}
                    placeholder={t("nav.create_button.create_presentation")}
                />
            </ProjectEditPageGridInput>
    )
}

export default CreatePresentationButton;